import { pipe } from '#/providers/creative/pipe.js';
import { filter } from 'rxjs';
import { addInterpolation } from '#/store/slices/interpolation.js';
import interpolate from '#/lib/interpolate.js';
import invariant from 'fbjs/lib/invariant.js';

export function fetchExtrasFactory(dependencies) {
  return function fetchExtras(creative) {
    const subRequests = [];
    /*
    for (const widgetKey in creative.i18nEntities.widgets) {
      const widget = creative.i18nEntities.widgets[widgetKey];
      if (widget.linkType?.startsWith('megogo://purchase/')) {
        subRequests.push(getPurchaseOptions(widget, dependencies));
      }
    }
    */
    const favoriteTemplate = /{{favorited\.[^}]+}}/;
    for (const widgetKey in creative.i18nEntities.widgets) {
      const widget = creative.i18nEntities.widgets[widgetKey];
      if (favoriteTemplate.test(widget.content) || favoriteTemplate.test(widget.linkType)){
        subRequests.push(getLastFavorite(widget, dependencies));
        break;
      }
    }

    if (!subRequests.length) {
      return Promise.resolve(creative);
    }

    return Promise.all(subRequests).then((injectors) =>
      pipe(...injectors)(creative),
    );
  };
}

function getPurchaseOptions(widget, dependencies) {
  const { hostGateway } = dependencies;
  const {
    promise,
    resolve,
    reject
  } = Promise.withResolvers();
  const videoId = widget.linkType.replace('megogo://purchase/', '');
  hostGateway.sendEvent('interactive:purchase', {
    videoId,
    stage: 'options'
  });

  const subscription = hostGateway.message$
    .pipe(
      filter((message) => message.cmd === 'purchase-options' && message.payload.videoId === videoId)
    )
    .subscribe((message) => {
      subscription.unsubscribe();
      if (message.payload.error) {
        reject(message.payload);
      }
      resolve((creative) => {
        creative.i18nEntities.widgets[widget.id].purchaseOptions = {
          available: message.payload.available,
          options: message.payload.options,
          extras: message.payload.extras
        };
        return creative;
      });
    });

  return promise;
}

function getLastFavorite(_widget, dependencies) {
  const {
    interactiveAPI: API,
    store,
  } = dependencies;
  const user = store.getState().user;

  invariant(user.profile_id, 'Missing required parameter"profile_id".');

  return API.getTrackerData(user.profile_id)
    .then((data) => {
      store.dispatch(addInterpolation({
        key: 'favorited.year',
        value: data?.year,
      }));
      store.dispatch(addInterpolation({
        key: 'favorited.title',
        value: data?.title.i18n[user.lang] ?? data?.title.i18n['en'] ?? data?.title.i18n['ua'] ?? data?.title.i18n[Object.keys(data?.title.i18n)[0]],
      }));
      store.dispatch(addInterpolation({
        key: 'favorited.type',
        value: data?.type // TODO: make remapping,
      }));
      store.dispatch(addInterpolation({
        key: 'favorited.id',
        value: data?.id
      }));
      store.dispatch(addInterpolation({
        key: 'favorited.json',
        value: JSON.stringify(data, null, 1)
      }));

      // TODO: instead push interpolation data to store,
      //  use i18nEntities or interpolate text content just in place?
      return (creative) => {
/*
        // disabled due to applying such interpolation globally,
        // see: create-link-interpolation
        const ctx = store.getState().interpolation;
        for (const widgetKey in creative.i18nEntities.widgets) {
          const widget = creative.i18nEntities.widgets[widgetKey];

          if (widget.linkType){
            widget.linkType = interpolate(widget.linkType, ctx);
          }
        }
*/
        return creative;
      }
    });
}
